import { flexRender, Table } from '@tanstack/react-table';
import React from 'react';
import { Load } from '../../../types';
import { useDraftsLoadsContext } from '../drafts-loads-context';
import { STATUS_COLUMN } from '../hooks/use-draft-load-columns';
import { useDraftLoadPreferences } from '../hooks/useDraftLoadPreferences';
import { gridTemplateColumnsGenerator } from '../utils/drafts-loads-utils';

interface LoadTableHeaderProps {
    table: Table<Load>;
}

export const LoadTableHeader: React.FC<LoadTableHeaderProps> = (props) => {
    const { table } = props;
    const { isDrafts } = useDraftsLoadsContext();
    const { showLoadDate, estimatedTotalTripMode, showTractor, showTrailer } = useDraftLoadPreferences();

    return (
        <div className='lt-header'>
            {table.getHeaderGroups().map(headerGroup => (
                <div
                    key={headerGroup.id}
                    className='lt-row'
                    style={{ gridTemplateColumns: gridTemplateColumnsGenerator(isDrafts, showLoadDate, estimatedTotalTripMode, showTractor, showTrailer) }}
                >
                    {headerGroup.headers.map(header => {
                        const isStatusColumn = header.id === STATUS_COLUMN;

                        return (
                            <div
                                key={header.id}
                                style={isStatusColumn ? { gridColumn: 'span 2' } : undefined}
                                className='lt-header-item'
                            >
                                {flexRender(header.column.columnDef.header, header.getContext())}
                            </div>
                        );
                    })}
                </div>
            ))}
        </div>
    );
};
